module.exports = __webpack_public_path__ + "static/media/2021_Cadillac_XT6_ext_04_6NW26_1SC_GB8.a5ef2a2c.png";